import React from "react";

import PropTypes from "prop-types";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  List,
  ListItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import Card from "../../components/Cards/Card";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LayoutWrapper from "../../components/LayoutWrapper/LayoutWrapper";
import { Footer } from "../../components/Footer/Footer";

function Faq({ app, config }) {
  return (
    <div className="app faq">
      <div className="appContent">
        <LayoutWrapper>
          <Card app={app} className="container-card-faq">
            <div className="container-titles">
              <h3>Perguntas Frequentes</h3>
            </div>

            <div>
              <Accordion sx={{ fontFamily: "Lato", margin: "16px 0" }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                  sx={{ fontWeight: "bold", fontFamily: "Lato" }}
                >
                  Quais são os indicadores e peso de cada um na apuração?{" "}
                </AccordionSummary>
                <AccordionDetails sx={{ fontSize: "16px" }}>
                  O Programa de Excelência Cargill é composto por dois
                  indicadores:
                  <strong>
                    {" "}
                    positivação total e positivação por categorias
                  </strong>
                  , sendo esse dividido em dez categorias. Na tabela você pode
                  consultar quais são as categorias e pesos dos indicadores:
                  <TableContainer className="container-table">
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell></TableCell>
                          <TableCell sx={{ fontWeight: "bold" }}>
                            RETAIL
                          </TableCell>
                          <TableCell sx={{ fontWeight: "bold" }}>
                            {" "}
                            FOOD SERVICE
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow>
                          <TableCell sx={{ fontWeight: "bold" }}>
                            Total
                          </TableCell>
                          <TableCell>0,50%</TableCell>
                          <TableCell>0,50%</TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell sx={{ fontWeight: "bold" }}>
                            EXTRATO DE TOMATE
                          </TableCell>
                          <TableCell>0,75%</TableCell>
                          <TableCell>0,50%</TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell sx={{ fontWeight: "bold" }}>
                            MOLHOS E POLPAS
                          </TableCell>
                          <TableCell>0,50%</TableCell>
                          <TableCell>0,50%</TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell sx={{ fontWeight: "bold" }}>
                            CHOCOLATE
                          </TableCell>
                          <TableCell>0,00%</TableCell>
                          <TableCell>0,50%</TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell sx={{ fontWeight: "bold" }}>
                            ÓLEOS E GORDURAS
                          </TableCell>
                          <TableCell>0,50%</TableCell>
                          <TableCell>0,50%</TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell sx={{ fontWeight: "bold" }}>
                            MAIONESE, MPS E CONDIMENTOS
                          </TableCell>
                          <TableCell>0,25%</TableCell>
                          <TableCell>0,25%</TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell sx={{ fontWeight: "bold" }}>
                            AZEITE E COMPOSTOS 0,50% 0,25%
                          </TableCell>
                          <TableCell>0,50%</TableCell>
                          <TableCell>0,25%</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                  Você pode notar que a somatória dos indicadores é 3%, ou seja,
                  esse é rebate máximo que a distribuidora poderá receber como
                  benefício.
                </AccordionDetails>
              </Accordion>

              <Accordion sx={{ fontFamily: "Lato", margin: "16px 0" }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                  sx={{ fontWeight: "bold" }}
                >
                  Bonificações são consideradas para apuração?
                </AccordionSummary>
                <AccordionDetails sx={{ fontSize: "16px" }}>
                  Não. As bonificações são desconsideradas da apuração, assim
                  como as devoluções que acontecem dentro do mês. Sendo assim,
                  para que um cliente seja considerado como positivado ele
                  precisa garantir que a venda seja maior que a
                  devolução/cancelamentos e bonificação.
                </AccordionDetails>
              </Accordion>

              <Accordion sx={{ fontFamily: "Lato", margin: "16px 0" }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                  sx={{ fontWeight: "bold", fontFamily: "Lato" }}
                >
                  Quando acontecem as apurações?
                </AccordionSummary>
                <AccordionDetails sx={{ fontSize: "16px" }}>
                  As apurações são feitas pelo time Cargill entre o 6 e 7° dia
                  útil. Após o fechamento o vendedor responsável pelo seu
                  atendimento receberá a apuração por e-mail e poderá
                  compartilhar com você.
                </AccordionDetails>
              </Accordion>

              <Accordion sx={{ fontFamily: "Lato", margin: "16px 0" }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                  sx={{ fontWeight: "bold", fontFamily: "Lato" }}
                >
                  Qual a fonte de dados de apuração?
                </AccordionSummary>
                <AccordionDetails sx={{ fontSize: "16px" }}>
                  Todos os dados para apuração do Programa de Excelência Cargill
                  são retirados do sistema MTRIX. É obrigação da distribuidora
                  repassar os dados diariamente e cumprir com a validação
                  mensal. Ao finalizar a validação mensal, que ocorre entre o 1
                  -3° dia útil do mês, a sua distribuidora já pode passar pela
                  apuração do PEC.
                </AccordionDetails>
              </Accordion>

              <Accordion sx={{ fontFamily: "Lato", margin: "16px 0" }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                  sx={{ fontWeight: "bold", fontFamily: "Lato" }}
                >
                  Qual o critério para que um cliente seja contabilizado como
                  uma positivação?
                </AccordionSummary>
                <AccordionDetails sx={{ fontSize: "16px" }}>
                  O seu cliente precisa cumprir algumas regras para que seja
                  contabilizado no indicador positivação, são elas:
                  <List>
                    <ListItem>
                      a. Estar localizado nas cidades de área de contrato. Caso
                      você tenha dúvida, consulte o seu contrato de distribuição
                      Cargill;
                    </ListItem>

                    <ListItem>
                      b. Ter venda (sell-out) maior do que as
                      devoluções/cancelamentos e bonificações no mês;
                    </ListItem>

                    <ListItem>
                      c. Comprar pelos menos 6 unidades do portifólio Cargill,
                      ou seja, se ele comprar 5 unidades não será considerado
                      como uma positivação ao final do mês;
                    </ListItem>
                  </List>
                  <strong>
                    É importante reforçar que a regra de compra mínima de 6
                    unidades é valida APENAS para a apuração do indicador de
                    POSITIVAÇÃO TOTAL EM RETAIL. Positivação total em Food
                    Service, não tem quantidade mínima de venda. Em CATEGORIAS,
                    também não tem quantidade mínima de venda.
                  </strong>
                </AccordionDetails>
              </Accordion>

              <Accordion sx={{ fontFamily: "Lato", margin: "16px 0" }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                  sx={{ fontWeight: "bold", fontFamily: "Lato" }}
                >
                  Clientes que compram com cadastro no CPF são contabilizados na
                  positivação?
                </AccordionSummary>
                <AccordionDetails sx={{ fontSize: "16px" }}>
                  Sim, desde que cumpra todas as regras citadas no item 5.
                  <p className="title-waring">
                    <strong>
                      Caso tenha dúvidas, envie sua pergunta para o vendedor que
                      faz o seu atendimento na Cargill.
                    </strong>
                  </p>
                </AccordionDetails>
              </Accordion>
            </div>
          </Card>

          <Footer app={app} />
        </LayoutWrapper>
      </div>
    </div>
  );
}

Faq.defaultProps = {
  app: null,
  config: {},
};

Faq.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default Faq;
